export function LandingAgitate() {
  return (
    <section className="min-h-screen w-full flex items-center justify-center bg-white text-black border-b-4 border-black px-6 md:px-20 md:snap-start relative">
      <div className="max-w-4xl py-20 space-y-12 text-center z-10 flex flex-col items-center select-none font-mono">
        
        {/* Headline */}
        <div className="space-y-4">
          <h2 className="text-3xl md:text-5xl font-black uppercase tracking-tight leading-[1]">
            Right Now, You’re the One Connecting the Dots.
          </h2>
          <p className="text-base md:text-xl font-bold uppercase tracking-tight text-zinc-600 max-w-xl mx-auto">
            You check 5 tools to find 1 answer.
          </p>
        </div>

        {/* Visual Pain Illustration */}
        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch pt-4 text-left">
          {/* Box 1: The Outdated Industry Mess (Multiple Alerts & Chaos) */}
          <div className="border-4 border-black p-6 space-y-4 bg-zinc-100 flex flex-col justify-between shadow-[4px_4px_0_0_#000]">
            <div className="space-y-3">
              <span className="font-mono text-[9px] font-black uppercase bg-red-500 text-white px-2 py-0.5">THE OLD WAY — NOISY ROBOTS</span>
              <p className="font-mono text-[10px] text-zinc-600 uppercase font-black">2:03 AM — PANIC TIMELINE & MULTIPLE ALERTS</p>
              
              {/* Simulated noisy alerts */}
              <div className="space-y-2">
                <div className="border border-red-200 bg-red-50 p-2.5 font-mono text-[9px] text-red-900 flex justify-between items-center">
                  <span>🚨 [DATADOG] CPU SPIKE 99% — api-prod</span>
                  <span className="font-black text-[8px] bg-red-200 px-1">2:03 AM</span>
                </div>
                <div className="border border-red-200 bg-red-50 p-2.5 font-mono text-[9px] text-red-900 flex justify-between items-center">
                  <span>🚨 [SENTRY] 1,429 Connection Timeout Errors</span>
                  <span className="font-black text-[8px] bg-red-200 px-1">2:04 AM</span>
                </div>
                <div className="border border-yellow-250 bg-yellow-50 p-2.5 font-mono text-[9px] text-yellow-900 flex justify-between items-center">
                  <span>🚨 [STRIPE] Webhook Delivery Failed — Checkout Stuck</span>
                  <span className="font-black text-[8px] bg-yellow-200 px-1">2:08 AM</span>
                </div>
                <div className="border border-zinc-300 bg-zinc-200/50 p-2.5 font-mono text-[9px] text-zinc-700 flex justify-between items-center">
                  <span>❔ [GITHUB] Deploy #423 completed by automated script</span>
                  <span className="font-black text-[8px] bg-zinc-300 px-1">2:12 AM</span>
                </div>
              </div>

              <div className="font-mono text-[9px] text-zinc-500 leading-snug space-y-1 bg-zinc-200/50 p-3 select-none">
                <p className="font-bold text-red-700">RESULT: You click through 5 dashboard tabs at 2:15 AM trying to figure out which telemetry signal actually caused the crash.</p>
              </div>
            </div>
            <p className="text-xs font-black uppercase text-zinc-700 leading-snug pt-2 border-t border-black/10">
              ❌ 20 mins of panic. Customers bounce. Sleep ruined.
            </p>
          </div>

          {/* Box 2: UptimeWing Resolution (One Single Answer with Root Cause + Suggestion) */}
          <div className="border-4 border-black p-6 space-y-4 bg-zinc-950 text-white flex flex-col justify-between shadow-[4px_4px_0_0_#ef4444]">
            <div className="space-y-3">
              <span className="font-mono text-[9px] font-black uppercase bg-emerald-500 text-black px-2 py-0.5 font-bold">UPTIMEWING</span>
              <p className="font-mono text-[10px] text-zinc-450 uppercase font-black font-bold">2:03 AM — ONE NOTIFICATION. RESOLVED IN 30s</p>
              
              {/* Simple unified dashboard card */}
              <div className="border-2 border-zinc-800 bg-zinc-900 p-4 font-mono text-xs space-y-3">
                <div className="flex justify-between items-center border-b border-zinc-800 pb-2">
                  <span className="text-red-500 font-bold uppercase">🔴 api-prod outage detected</span>
                  <span className="text-[8px] bg-zinc-800 text-zinc-400 px-1">2:03:12 AM</span>
                </div>
                
                <div className="space-y-2 text-[10px]">
                  <div>
                    <span className="text-zinc-500 block uppercase text-[8px] font-black">Identified Root Cause:</span>
                    <p className="text-zinc-200">Deploy #423 triggered an unindexed DB migration causing database pools to timeout.</p>
                  </div>
                  
                  <div>
                    <span className="text-zinc-500 block uppercase text-[8px] font-black">Operational Impact:</span>
                    <p className="text-zinc-200">Stripe checkout webhook blocked (12% of transaction traffic affected).</p>
                  </div>

                  <div className="bg-[#FFFF00]/10 border border-[#FFFF00]/30 p-2.5 text-[#FFFF00] flex justify-between items-center">
                    <div>
                      <span className="block text-[7px] font-black uppercase text-[#FFFF00]/80">Recommended Action:</span>
                      <code className="text-[9px]">vercel rollback --env=production</code>
                    </div>
                    <span className="text-[7px] border border-[#FFFF00] px-1 font-black shrink-0">COPY FIX</span>
                  </div>
                </div>
              </div>
            </div>
            <p className="text-xs font-black uppercase text-emerald-400 leading-snug pt-2 border-t border-white/10">
              ✓ 30 seconds. One clean notification. Back to sleep.
            </p>
          </div>
        </div>

        {/* Subtext */}
        <div className="space-y-2 max-w-xl mx-auto pt-6">
          <p className="text-lg md:text-xl font-black uppercase">One notification. The answer. Done.</p>
        </div>

      </div>
    </section>
  );
}
